// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Offcanvas, Button, Collapse } from 'react-bootstrap';
import Tema from '../../context/Tema';
import './Navbar.css';
import MenuComponente from './MenuComponente';
import { useProvider } from '../../context/MenuProvider'; // Importa o contexto do Menu

const  CatalogoNavbar = () => {
  const { 
    setLinks, 
    setBtns, 
    crudCliente, 
    setTokenCliente, 
    userCliente, 
    loja, 
    setLoja, 
    site, 
    excluirDadosPorId, 
    buscarDadosPorId, 
    salvarDados,
    title,
  } = useProvider(); // Acessa a função setLinks para atualizar os links do menu
  const { get, loading, error } = crudCliente || {};
  const [isOpen, setIsOpen] = useState(false);
  const [openCollapse, setOpenCollapse] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { tipo } = useParams();
  
  const queryParams = new URLSearchParams(location.search);
  

  // Títulos das páginas
  const titles = {
    '/catalogo': 'Catálogo',
  };

  const queryTitulo = (value) =>{
    switch (value) {
      case 'meus-pedidos':
        return "Meus Pedidos";
      case 'comprovante':
        return "Minha compra";
      case 'contato':
        return "Contatos";
      case 'perfil':
        return "Meu Perfil";
      case 'login':
        return "Autenticação";
      case 'adicionar-produto':
        return "Produto";
      case 'checkout':
        return "Checkout";
      case 'endereco':
        return "Endereço";
      case 'feedback':
        return "Feedback";
    }
  }
 
  const backButtonRoutes = ['/produtos'];
  
  const rotasVoltar = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const pagina = queryParams.get('p')?.toLowerCase();
    const id = queryParams.get('id')?.toLowerCase();
    const i = queryParams.get('i')?.toLowerCase();
    const lista=[
      ...(id?[`id=${id}`]:[]),
      `p=checkout`,
      `p=endereco`,
      `p=feedback`,
      `p=comprovante&i=${i}`,
    ]
    backButtonRoutes.push(...lista);
  };
  
  rotasVoltar();
  //const showBackButton = backButtonRoutes.some(route => location.pathname.startsWith(route));
  const showBackButton = backButtonRoutes.some(route => 
      location.pathname.startsWith(route) || location.search.includes(route)
  );
    
  // Define o título da página com base na rota
  let pageTitle = titles[location.pathname] || queryTitulo(queryParams.get('p')?.toLowerCase()) || title;


  const toggleMenu = () => setIsOpen(!isOpen);
  const handleBack = () => navigate(-1);

  // Define os links iniciais para o MenuComponente
  useEffect(() => {
    setLinks([
      //{ name: 'Perfil', to: '/' },
      //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    setBtns([
      //{ name: 'Perfil', to: '/' },
      //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns]);

  // Itens de menu com opções que podem ser expandidas
  const menuItems = [
    {
        title: 'Gestão',
        icon: 'bi bi-bag-fill',
        links: [
          { name: 'Contatos', to: '?p=contato' },
          ...(userCliente ? [
            { name: 'Meus Pedidos', to: '?p=meus-pedidos' },
            { name: 'Meu Perfil', to: '?p=perfil' },
          ]:[
            { name: 'Pedidos', to: '?p=meus-pedidos' },
          ]),
        ],
    },
    {
      title: 'Suporte',
      icon: 'bi bi-life-preserver',
      links: [
        { name: 'Suporte sobre o App', onClick:()=>suporteWhatsApp()},
      ],
    },
  ];
  
  const suporteWhatsApp = () => {
    const texto = `Olá Francisco\nEstou com uma dúvida/dificuldade ao usar o App ${document.title}\nAssim que possível, entra em contato comigo :)`;
    const mensagem = encodeURIComponent(texto);
    const url = `whatsapp://send?phone=+5511966175193&text=${mensagem}`;
    window.open(url);
  }
  
  const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
  const divulgarApp = async () => {
    let texto = `Olá, tudo bom?\nEu uso esse App que me ajuda no controle das minhas vendas, você também vai gostar...\n\n${window.location.origin}/instalar-app/${loja?.empresa?.url || randomNumber}/`;
  
    if (site?.empresa) {
      texto = `Olá, tudo bom?\nEu uso o app *${site.empresa.nome_curto}*, estou gostando muito e você também pode gostar.\n\n${site.empresa.descricao}\nDisponível em:\nhttps://${site.domain}`;
    } else if (loja) {
      const nomeApp = loja.nome_curto;
      const nomeLoja = loja.catalogo?.nome_da_loja || "";
      const descricaoLoja = loja.catalogo?.descricao || "";
      const urlCatalogo = loja.catalogo?.url;
  
      texto = `Olá, tudo bom?\n\nEu uso o app ${nomeApp} para fazer minhas compras com *${nomeLoja}* ${descricaoLoja}\n\nEstou gostando e você também pode gostar...\nDisponível em:\n${window.location.origin}/catalogo/${urlCatalogo}/`;
    }
  
    const mensagem = encodeURIComponent(texto);
    const url = `whatsapp://send?text=${mensagem}`;
    window.open(url, "_blank");
  };
  
  const handleCollapseToggle = (index) => {
    setOpenCollapse(openCollapse === index ? null : index);
  };
  
  const btn = {
    onClick:toggleMenu,
    className:"text-start w-100 btn",
  }
  
  const sair =async()=>{
    try{
      setTokenCliente(null);
      await excluirDadosPorId('local_registros','cliente');
      navigate('/', { replace: true });
    }catch(err){
      
    }
  }

  return (
    <>
      <div 
        className="navbar navbar-light py-2 fixed-top shadow"
        style={{
          borderBottom: loading
            ? '3px solid orange'
            : error
            ? error?.name === 'CanceledError'
              ? ''
              : '3px solid red'
            : ''
        }}
      >
        <div className="container fs-5 d-flex align-items-center">
            {(showBackButton && location.key !== 'default') ? (
              <Button variant="transparent" onClick={handleBack} className="me-3">
                &larr;
              </Button>
            ) : (
              <Button variant="transparent" onClick={toggleMenu} className="me-3">
                &#9776;
              </Button>
            )}
          {/* Texto que deve cortar */}
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: 1 // ocupa o espaço restante
            }}
          >
            {pageTitle || title || site?.name}
          </div>
          <MenuComponente /> {/* O MenuComponente renderiza os links dinamicamente */}
        </div>
      </div>

      <Offcanvas show={isOpen} onHide={toggleMenu} placement="start" className="navbar-light">
        <Offcanvas.Header closeButton closeVariant="transparent">
          <Offcanvas.Title>{site?.nome_curto}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Link to={`/c/${site?.empresa?'':`${loja?.url}/`}`} onClick={toggleMenu} className="w-100 text-start btn">
            <i className="bi bi-house-fill"></i> Página Inicial
          </Link>
          <Link to={`/painel`} onClick={toggleMenu} className="w-100 text-start btn">
            <i className="bi bi-ui-radios-grid"></i> Painel Admin
          </Link>
          
          {/* Itens do menu dinâmico com collapse */}
          {menuItems.map((item, index) => (
            <div key={index}>
              <Button
                variant="btn"
                onClick={() => {handleCollapseToggle(index); if(item.onClick) item.onClick();}}
                className="w-100 text-start btn text-decoration-none"
              >
                <i className={item.icon}></i> {item.title}
              </Button>
              <Collapse in={openCollapse === index}>
                <div>
                  <ul className="list-unstyled">
                    {item.links.map((link, idx) => (
                      <li key={idx}>
                        <Link to={link.to} className="text-start w-100 btn ms-3" onClick={()=>{toggleMenu(); if(link.onClick) link.onClick();}}>
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </Collapse>
            </div>
          ))}

          <Link onClick={() => { toggleMenu(); divulgarApp(); }} className="text-start w-100 btn">
            <i className="bi bi-share-fill"></i> Divulgar App
          </Link>
          <Tema/>
          <Link to="?p=perfil" onClick={()=>{toggleMenu(); sair();}} className="text-start w-100 btn">
            <i className="bi bi-box-arrow-right"></i> {userCliente?"Sair":"Login"}
          </Link>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default CatalogoNavbar;